// import React from 'react'
// import Box from '@mui/material/Box';
// import Typography from '@mui/material/Typography';
// import Grid from '@mui/material/Grid';
// import Paper from '@mui/material/Paper';
// import Table from '@mui/material/Table';
// import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
// import TableBody from '@mui/material/TableBody';
// import TableCell from '@mui/material/TableCell';
// import TableRow from '@mui/material/TableRow';

// import { useEffect } from 'react';
// import User from '../services/db/user'
// import camelToSentence from '../utils/camelToSentence'
// import { useState } from 'react';
// // import { useState } from 'react';

// const dayWiseStats = [
//     { title: 'Today', day: 1 },
//     { title: 'Past 7 days', day: 7 },
//     { title: 'Past 1 month', day: 30 },
//     { title: 'Total' },
// ]

// const config = {
//     users: dayWiseStats,
//     serviceProviders: [
//         { title: "Photography" },
//         { title: "Videography" },
//         { title: "Designing" },
//         { title: "Editing" },
//     ],
//     businessEarn: dayWiseStats
// }
// const DashDetails = () => {
//     const [data, setdata] = useState({
//         users: [],
//         serviceProviders: [],
//         businessEarn: [],
//         useLoading: false,
//         serviceProvidersLoading: false,
//         businnesEarnLoading: false
//     });

//     useEffect(() => {
//         if (data.users.length !== config.users.length) {
//             config.users.forEach((el) => {
//                 new User().users(el.day).then(dt => {

//                     console.log('first', el.day)

//                     console.log('data', dt)
//                     setdata(prev => ({ ...prev, users: [...prev.users, dt] }))
//                 })
//             })
//         }
//         if (data.serviceProviders.length !== config.serviceProviders.length) {
//             config.serviceProviders.forEach(el => {
//                 new User().serviceProviders(el.title).then(dt => {
//                        console.log('1', dt)
//                     setdata(prev => ({ ...prev, serviceProviders: [...prev.serviceProviders, dt] }))
//                 })
//             })
//         }
//         if (data.businessEarn.length !== config.businessEarn.length) {
//             config.businessEarn.forEach(el => {
//                 new User().businessEarn(el.day).then(dt => {
//                        console.log('1', dt)
//                     setdata(prev => ({ ...prev, businessEarn: [...prev.businessEarn, dt] }))
//                 })
//             })
//         }
//     }, []);

//     return (
//         <Box>
//             <Grid container direction='column' maxWidth={'md'} gap={2} paddingLeft={5} >
//                 {Object.keys(config).map(ele => (
//                     <Grid
//                         container
//                         direction='row'
//                         justifyContent='flex-start'
//                         p={3}
//                         xs={6}
//                         item
//                         marginTop={5}
//                         sx={{
//                             bgcolor: '#fff3e0',
//                             borderRadius: '20px'
//                         }}
//                         key={ele}
//                     >
//                         <Typography variant='h6'>Total {camelToSentence(ele)}</Typography>
//                         <TableContainer component={Paper}>
//                             <Table sx={{ bgcolor: '#fff' }}>
//                                 <TableHead>
//                                     <TableRow>
//                                         {config[ele].map(el => (
//                                             <TableCell key={el.title}>{el.title}</TableCell>
//                                         ))}
//                                     </TableRow>
//                                 </TableHead>
//                                 <TableBody>
//                                     <TableRow>
//                                         {config[ele].map((el, id) => (
//                                             <TableCell key={`${el.title}-val`}>
//                                                 {data[ele][id]}
//                                                 {/* {[el][id] || 0} */}
//                                             </TableCell>
//                                         ))}
//                                     </TableRow>
//                                 </TableBody>
//                             </Table>
//                         </TableContainer>
//                     </Grid>
//                 ))}
//             </Grid>
//         </Box>
//     )
// }

// export default DashDetails

import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import User from "../services/db/user";
import camelToSentence from "../utils/camelToSentence";

const dayWiseStats = [
  { title: "Today", day: 1 },
  { title: "Past 7 days", day: 7 },
  { title: "Past 1 month", day: 30 },
  { title: "Total" },
];

const config = {
  users: dayWiseStats,
  serviceProviders: [
    { title: "Photography" },
    { title: "Videography" },
    { title: "Designing" },
    { title: "Editing" },
  ],
  businessEarn: dayWiseStats,
};

const DashDetails = () => {
  const [data, setData] = useState({
    users: [],
    serviceProviders: [],
    businessEarn: [],
    useLoading: false,
    serviceProvidersLoading: false,
    businnesEarnLoading: false,
  });

  useEffect(() => {
    const fetchData = async () => {
      const userApi = new User();

      const usersResults = await Promise.all(
        config.users.map((el) => userApi.users(el.day))
      );
   
      const spResults = await Promise.all(
        config.serviceProviders.map((el) => userApi.serviceProviders(el.title))
      );
     
      const earnResults = await Promise.all(
        config.businessEarn.map((el) => userApi.businessEarn(el.day))
      );

      setData({
        users: usersResults,
        serviceProviders: spResults,
        businessEarn: earnResults,
        useLoading: false,
        serviceProvidersLoading: false,
        businnesEarnLoading: false,
      });
    };

    fetchData();
  }, []);

  return (
    <Box>
      <Grid
        container
        direction="column"
        maxWidth={"md"}
        gap={2}
        paddingLeft={5}
      >
        {Object.keys(config).map((ele) => (
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            p={3}
            xs={6}
            item
            marginTop={5}
            sx={{
              bgcolor: "#fff3e0",
              borderRadius: "20px",
            }}
            key={ele}
          >
            <Typography variant="h6">Total {camelToSentence(ele)}</Typography>
            <TableContainer component={Paper}>
              <Table sx={{ bgcolor: "#fff" }}>
                <TableHead>
                  <TableRow>
                    {config[ele].map((el) => (
                      <TableCell key={el.title}>{el.title}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    {config[ele].map((el, id) => (
                      <TableCell key={`${el.title}-val`}>
                        {data[ele][id] ?? 0}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default DashDetails;
